import { enumerateDaysBetweenDates } from "@/lib/enumerateDaysBetweenDates";
import Excel from "exceljs";
import moment from "moment";

export default function extractSpecialShift(file, userData, selectedDate) {
  return new Promise(async (resolve, reject) => {
    const wb = new Excel.Workbook();
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    let specialShiftData = [];
    const startDate = moment(selectedDate).startOf("month");
    const endDate = moment(selectedDate).endOf("month");
    const dateRange = enumerateDaysBetweenDates(startDate, endDate);
    reader.onload = () => {
      const buffer = reader.result;
      try {
        wb.xlsx.load(buffer).then(async (workbook) => {
          const salesDataWorkSheet = workbook.getWorksheet(1);
          salesDataWorkSheet.eachRow((row, rowIndex) => {
            if (rowIndex === 1) {
              row.eachCell((cell, col) => {
                if (col >= 2) {
                  const currentDate = moment(cell.value);
                  console.log("currentDate.isValid()", currentDate.isValid());
                  if (
                    currentDate.isValid() &&
                    !currentDate.isBetween(startDate, endDate, "day", "[]")
                  ) {
                    reject({ message: "dateIsNotCorrect" });
                    return false;
                  }
                }
              });
            }
            if (rowIndex >= 2 && row.values[1]) {
              let columnIndex = 2;
              dateRange.forEach((date) => {
                if (row.values[columnIndex]) {
                  const staff_code = row.values[1].toLowerCase();
                  if (!userData[staff_code]) {
                    reject({ message: "userNotExist", id: row.values[1] });
                    return false;
                  }
                  specialShiftData.push({
                    date,
                    user: {
                      label: `${userData[staff_code].alias}(${userData[staff_code].staff_code})`,
                      value: userData[staff_code].id,
                      staff_code: userData[staff_code].staff_code,
                    },
                    remark: row.values[columnIndex],
                  });
                }
                columnIndex++;
              });
            }
          });
          resolve(specialShiftData);
        });
      } catch (err) {
        console.log(err);

        throw err;
      }
    };
  });
}
